import { Grid } from "@mui/material";

import {
  RRDCouponGrid,
  RRDExpirationText,
  RRDImageSlot,
  RRDPageLabel,
} from "./RRDTemplateSlots";
import { couponSlots, slotsByType } from "./rrdLayoutSlotHelpers";
import type { RRDLayoutProps } from "./layoutTypes";

function MegaSheetLayout(props: RRDLayoutProps) {
  const { layoutSpec, heroImages, coupons, frontExpirationDate, mode } = props;
  const largeHeroSlot = slotsByType(layoutSpec, "large_hero_image")[0];
  const mediumHeroSlot = slotsByType(layoutSpec, "medium_hero_image")[0];

  return (
    <>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Front</RRDPageLabel>
        <RRDImageSlot
          {...props}
          slot={largeHeroSlot}
          placeholder="Large Hero Image"
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Back</RRDPageLabel>
        <RRDImageSlot
          {...props}
          slot={mediumHeroSlot}
          placeholder="Medium Hero Image"
        />
        <RRDCouponGrid
          slots={couponSlots(layoutSpec, "back")}
          layoutSpec={layoutSpec}
          heroImages={heroImages}
          coupons={coupons}
          mode={mode}
          onOpenMobileSlot={props.onOpenMobileSlot}
          onRemoveAsset={props.onRemoveAsset}
          readOnly={props.readOnly}
        />
        <RRDExpirationText>{frontExpirationDate}</RRDExpirationText>
      </Grid>
    </>
  );
}

export default MegaSheetLayout;
